(() => {
  "use strict";

  window.MinacoHeaderFeatures = window.MinacoHeaderFeatures || {};

  window.MinacoHeaderFeatures.country = (MinacoHeader, SELECTORS) => {
    class MinacoHeaderCountryFeature {
    bindCountrySelector() {
      if (!this.countrySelector || !this.countryToggle) {
        return;
      }

      this.on(this.countryToggle, "click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.countryOpen) {
          this.closeCountrySelector({
            restoreFocus: false,
          });
        } else {
          this.openCountrySelector(this.countryToggle);
        }
      });

      this.header
        .querySelectorAll(SELECTORS.countryOption)
        .forEach((option) => {
          this.on(option, "click", (event) => {
            event.preventDefault();

            const code = option.dataset.countryCode;

            if (!code || !this.countryInput) {
              return;
            }

            this.countryInput.value = code;

            const form = this.countryInput.closest("form");

            if (form) {
              HTMLFormElement.prototype.submit.call(form);
            }
          });
        });
    }

    openCountrySelector(trigger = null) {
      if (!this.countrySelector) {
        return;
      }

      this.countryReturnFocus = trigger || document.activeElement;

      this.closeMegaMenus({
        reconcile: false,
      });

      this.closeSearch({
        reconcile: false,
      });

      this.closeMobileDrawer({
        reconcile: false,
      });

      this.countryOpen = true;

      this.countrySelector.classList.add("is-open");

      this.countryDropdown?.classList.add("is-open");

      this.countryToggle?.setAttribute("aria-expanded", "true");

      this.countryDropdown?.setAttribute("aria-hidden", "false");

      this.reconcileState();
    }

    closeCountrySelector({ restoreFocus = false, reconcile = true } = {}) {
      if (!this.countrySelector) {
        return;
      }

      const wasOpen = this.countryOpen;

      this.countryOpen = false;

      this.countrySelector.classList.remove("is-open");

      this.countryDropdown?.classList.remove("is-open");

      this.countryToggle?.setAttribute("aria-expanded", "false");

      this.countryDropdown?.setAttribute("aria-hidden", "true");

      if (reconcile) {
        this.reconcileState();
      }

      if (
        restoreFocus &&
        wasOpen &&
        this.isConnected(this.countryReturnFocus)
      ) {
        this.countryReturnFocus.focus();
      }
    }

    }

    Object.getOwnPropertyNames(MinacoHeaderCountryFeature.prototype).forEach((methodName) => {
      if (methodName === "constructor") {
        return;
      }

      Object.defineProperty(
        MinacoHeader.prototype,
        methodName,
        Object.getOwnPropertyDescriptor(MinacoHeaderCountryFeature.prototype, methodName),
      );
    });
  };
})();
